import { __ } from "@wordpress/i18n";
import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import Hint from '../components/Hint/Hint';
import InfoBox from '../components/InfoBox/InfoBox';
import { useMenu } from '../contexts/MenuContext';
import { formDataPost } from "../helpers/Helpers"; // Import utility function
import withForm from '../layouts/withForm';
const SecurityInjectionGuardUserAgents = ({handleChange}) => {  
    const {
        settingData,
        setReload
    } = useMenu();
    const methodList = ['GET','POST','PUT','PATCH','DELETE','HEAD','OPTIONS'];   
    // For data table
    const [selectedRows, setSelectedRows] = useState([])
    const [toggleCleared, setToggleCleared] = useState(false)

    const [bulkAction, setBulkAction] = useState("-1")
    const [tableData, setTableData] = useState([])
    const [filteredTableData, setFilteredTableData] = useState([])
    const [searchQuery, setSearchQuery] = useState('')
    const [reloadDatatable, setReloadDatatable] = useState(0)

    // Get roles data
    const columns = [
        {
            name: 'Timestamp',
            selector: row => row.user_agent,
            sortable: true,
        },
        {
            name: 'Action',
            cell: row => (
                <button 
                    type="button" 
                    className="button button-link" 
                    onClick={() => handleDelete(row.index, row.user_agent)}
                    disabled={processing}
                >
                    {
                       __( `Delete`, "ultimate-security" )
                       // ${row.index} 
                    }
                </button> 
            ),
        },
    ];
    const toggleBlocked = (id) => {
        const updated = [...tableData];
        const index = updated.findIndex(row => row.id === id);
        if (index !== -1) {
            updated[index].blocked = (updated[index].blocked == 'allow')?'blocked':'allow';
            handleChange(`security.url_guard.requests_log.${id}.blocked`, updated[index].blocked);
            setTableData(updated);
            setFilteredTableData(updated); // If you're filtering
        }
    };

    // Get injection guard data
    // useEffect(() => {        
    //     setSearchQuery('');
    //     const getTableData = async () => {
    //         try {
    //             const response = await apiFetch({
    //                 path: '/ultimate-security/v1/injection-guard',
    //                 method: 'GET'
    //             });    
    //             setTableData(response);
    //             setFilteredTableData(response);             
    //         } catch (error) {
    //             console.error(error);
    //         }
    //     };    
    //     getTableData();
    // }, [reloadDatatable]);

    useEffect(() => {
        const user_agents = settingData?.security?.url_guard?.user_agents || {};
        const rows = [];
        Object.entries(user_agents).forEach(user_agent => {
            rows.push({
                index:user_agent[0],
                user_agent:user_agent[1]
            });
        });
        setTableData(rows);
        setFilteredTableData(rows);
    }, [settingData]);

    const handleSelectedRowsChange = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
    };

    const handleDatatableSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        const newData = tableData.filter(row => {
            // return row.param.toLowerCase().includes(query.toLowerCase());
            return (
                row.user_agent.toLowerCase().includes(query) 
                // || row.path.toLowerCase().includes(query) 
                // || row.date.toLowerCase().includes(query)
            );
        });
        setFilteredTableData(newData);
    }

    const handleBulkActionChange = (e) => {
        setBulkAction(e.target.value);
    };    
    const handleBulkActionSubmit = async () => {
        if (selectedRows.length) {
            const items = selectedRows.map(item => 
                item.user_agent,
            );
            // console.log(items);

            if (bulkAction !== "-1") {
                // console.log(items);
                const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
                if (confirmed) {
                    try {
                        const result = await formDataPost('ultimate_security_delete_multiple_useragent',{"items": items});
                        // console.log(result);
                        if (result.success_message) {
                            setReload(Math.random); 
                            setBulkAction("-1"); // Reset bulk action dropdown  
                            // console.log('xxx'); 
                            // Clear selected rows
                            setToggleCleared(!toggleCleared); // Toggle to trigger clear
                        }
                            
                    } catch (error) {
                        // console.log(error.message);
                    } finally {}
                }

            } else {
                alert("Please select a valid action.");
            }
        } else {
            alert("Please select users.");
        }
    };
    
    // For data table
    const [useragent, setQuerystring] = useState('');
    const [processing, setProcessing] = useState(false)
    const [processingRing, setProcessingRing] = useState(false)
    const [processingTick, setProcessingTick] = useState(false)
    const handleCreate = async () => {
        if(useragent.trim() == "" || useragent.trim() == null) {
            alert(__( 'Please fill the required form', 'ultimate-security' ));
            return false;
        }

        setProcessing(true);
        setProcessingRing(true);

        try {
            const result = await formDataPost(
                "ultimate_security_create_useragent", 
                {
                    useragent: useragent.trim(),
                }
            );
            // console.log('result: ',result) 
            if (result.success_message) {
                setProcessingRing(false);
                setProcessingTick(true)
                setReload(Math.random)
                setTimeout(()=> {
                    setQuerystring('');
                    setProcessingTick(false);
                    setProcessing(false);
                },1000)
            }
                
            // setReload(prev => !prev); // Trigger reload to force re-render
        } catch (error) {
            // console.log(error.message);
        } finally {
            setProcessing(false);
            setProcessingRing(false)
        }       
    }
    const handleDelete = async (index, value) => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            try {
                const result = await formDataPost('ultimate_security_delete_useragent',{"index": index, "useragent": value});
                // console.log(result);
                if (result.success_message) {
                    setReload(Math.random); 
                }
                    
            } catch (error) {
                // console.log(error.message);
            } finally {}
        }
    };
    return (
        <>            
            <div className="setting-unit pt-lg pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("User Agents", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Lorem ipsum, dolor sit amet consectetur adipisicing elit. Commodi suscipit est autem placeat praesentium reiciendis officiis, et veritatis eos saepe.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hints", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={useragent}
                                        onChange={(e) => setQuerystring(e.target.value)}
                                        required={true}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <InfoBox className="small-infobox" title={__( "Note", "ultimate-security" )} content={__( "You can use these keywords: HTTrack, clshttp, archiver, loader, email, harvest, autoemailspider, ExtractorPro, libwww, curl, wget, python", "ultimate-security" )} />
                                </div>
                                <div className="content-below-with-hint mt-2"> 
                                    <div className="d-flex align-items-center gap-2">                                    
                                        <button 
                                            type="button" 
                                            className="button button-link" 
                                            onClick={handleCreate}
                                            disabled={processing}
                                        >
                                            {
                                                processing ? __( "Processing...", "ultimate-security" ) : __( "Submit", "ultimate-security" )
                                            }
                                        </button>
                                        {processingRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                        {processingTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}
                                    </div>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit">
                <div className="user-datatable datatable-unit">
                    <div className="row justify-content-between mb-30">
                        <div className="col-8 filters">
                            <div className="bulk-action-wrapper mt-0">
                                <select value={bulkAction} name="action" onChange={handleBulkActionChange}>
                                    <option value="-1">{__('Bulk actions', 'ultimate-security')}</option>
                                    <option value="delete">{__('Delete', 'ultimate-security')}</option>
                                </select>
                                <button className="button button-secondary" onClick={handleBulkActionSubmit}>{__('Apply', 'ultimate-security')}</button>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="search-unit d-flex gap-2 align-items-center">
                                <input 
                                    placeholder="Search" 
                                    type="search" 
                                    onChange={handleDatatableSearch} 
                                    value={searchQuery} 
                                />
                                <button className="button button-secondary" type="button">
                                    {__('Search', 'ultimate-security')}
                                </button>
                            </div>
                        </div>
                    </div>            
                    <div className="table-wrapper">
                        <DataTable
                            columns={columns}
                            data={filteredTableData} // Use filtered data
                            selectableRows
                            onSelectedRowsChange={handleSelectedRowsChange}
                            clearSelectedRows={toggleCleared}
                            pagination
                            paginationPerPage={15} // Default to 5 rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 25, 50, 100]} // Options with 5 first
                            dense
                            responsive
                        />
                    </div> 
                </div> 
            </div>
        </>
    )
}
export default withForm(SecurityInjectionGuardUserAgents);